import HeroHeader from './HeroHeader/HeroHeader';

export default HeroHeader;
